/**
 *
 * @param {number} args.sectionPassPriceCents - the price of the section pass as defined on *Section*, if not on section use *SettingsSectionPassPricing*
 * @param {number} args.totalRebateAmountCents - the sum of all price fields of *UserProfileSectionPassRebate* docs where consumed at is not set (falsy)
 * @returns {{
 *   costAfterRebate: number,
 *   rebateCentsToApply: number
 * }}
 *   - costAfterRebate: the final price to charge (in cents), but free (0) if under $1.00
 *   - rebateCentsToApply: how many rebate cents were actually used
 */
export function getSectionPassPriceAfterRebate({
  sectionPassPriceCents,
  totalRebateAmountCents,
}: {
  sectionPassPriceCents: number
  totalRebateAmountCents: number
}) {
  // You can only apply as much rebate as the price itself
  const rebateCentsToApply = Math.min(
    sectionPassPriceCents,
    totalRebateAmountCents
  )

  // Subtract the rebate to get the raw cost
  const rawCost = sectionPassPriceCents - rebateCentsToApply

  // Stripe requires a minimum $1.00 charge, otherwise make it free
  const costAfterRebate = rawCost >= 100 ? rawCost : 0

  return { rebateCentsToApply, costAfterRebate }
}
